import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist';
import { baseApi } from '@/store/api/baseApi';
import '@/modules/categories/categoriesApi';
import '@/modules/subcategories/subcategoriesApi';
import '@/modules/brands/brandsApi';
import '@/modules/attributes/attributesApi';
import '@/modules/attribute-values/attributeValuesApi';
import '@/modules/banners/bannersApi';
import '@/modules/collections/collectionsApi';
import '@/modules/media/mediaApi';
import '@/modules/products/productsApi';
import '@/modules/dashboard/dashboardApi';
import '@/modules/reports/reportsApi';
import '@/modules/cms/cmsApi';
import '@/modules/seo/seoApi';
import '@/modules/email-templates/emailTemplatesApi';
import '@/modules/blogs/blogsApi';
import '@/modules/notifications/notificationsApi';
import '@/modules/enquiries/enquiriesApi';
import '@/modules/contacts/contactsApi';
import { setAppStore } from '@/store/storeInstance';
import authReducer from '@/store/authSlice';
import uiReducer, { type UiState } from '@/store/uiSlice';
import storage from '@/store/storage';

const uiPersistConfig = {
  key: 'ui',
  storage,
  partialize: (state: UiState) => ({
    sidebarCollapsed: state.sidebarCollapsed,
  }),
};

const persistConfig = {
  key: 'betiyan-admin',
  storage,
  whitelist: ['auth'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  ui: persistReducer(uiPersistConfig, uiReducer),
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
});

setAppStore(store);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
